import { render } from "./MainLayout.vue?vue&type=template&id=6aeb7e1c"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chmonya\\Desktop\\Обучалки\\vue.js\\15-crm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__